export default {"src":"/_next/static/media/phone_white_outline_24.875c8a0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};